/**
 * fayn: Produktreihe im Warenkorb.
 *
 * Liegt bewusst als eigene Asset-Datei vor und nicht als Inline-Skript im
 * Snippet. Die Reihe wird nur bei gefuelltem Warenkorb gerendert; kommt sie
 * per Section-Morph nach, fuehrt der Browser Inline-Skripte darin nicht aus.
 * Die Listener haengen deshalb am document und ueberleben jeden Neuaufbau.
 */
(() => {
  if (window.__faynCartUpsellBound) return;
  window.__faynCartUpsellBound = true;

  const CARD_GAP = 10;

  /**
   * Der Rabattcode der Karte wird nur gesetzt, wenn im Warenkorb noch kein
   * Code aktiv ist. Ein vorhandener Code wird nie ersetzt.
   */
  const cartHasDiscountCode = (cart) => {
    if (Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0) return true;
    if (
      Array.isArray(cart.cart_level_discount_applications) &&
      cart.cart_level_discount_applications.some((entry) => entry && entry.type === 'discount_code')
    ) {
      return true;
    }
    return document.querySelector('.cart-discount__pill') !== null;
  };

  const getDatoraClient = () => {
    if (window.co2 && typeof window.co2.setDiscountCode === 'function') return window.co2;
    return typeof co2 !== 'undefined' && co2 && typeof co2.setDiscountCode === 'function' ? co2 : null;
  };

  const isRejected = (result) => {
    if (result === false || result == null) return true;
    if (typeof result !== 'object') return false;
    if (result.applied === false || result.success === false || result.ok === false) return true;
    if (typeof result.status === 'string' && ['error', 'failed', 'invalid'].includes(result.status.toLowerCase())) {
      return true;
    }
    if (Array.isArray(result.errors) && result.errors.length > 0) return true;
    return Boolean(result.error);
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    return response.json();
  };

  /**
   * Pfeile werden nur optisch abgeblendet, nie hart deaktiviert. Ein
   * geschlossener Drawer misst 0 Pixel breit; eine harte Deaktivierung waere
   * dort dauerhaft und liesse sich beim Oeffnen nicht mehr aufheben.
   */
  const updateArrows = (root) => {
    const track = root.querySelector('[data-fayn-upsell-track]');
    const prev = root.querySelector('[data-fayn-upsell-prev]');
    const next = root.querySelector('[data-fayn-upsell-next]');
    if (!track) return;

    if (track.clientWidth === 0) {
      if (prev) prev.removeAttribute('aria-disabled');
      if (next) next.removeAttribute('aria-disabled');
      return;
    }

    const max = track.scrollWidth - track.clientWidth;
    if (prev) prev.setAttribute('aria-disabled', track.scrollLeft <= 1 ? 'true' : 'false');
    if (next) next.setAttribute('aria-disabled', max <= 1 || track.scrollLeft >= max - 1 ? 'true' : 'false');
  };

  // Beim Oeffnen des Drawers springt die Breite von 0 auf den echten Wert.
  // Dann wird nachgemessen.
  const watchSize = (root) => {
    const track = root.querySelector('[data-fayn-upsell-track]');
    if (!track || track.dataset.faynSizeWatched === 'true') return;
    if (typeof ResizeObserver === 'undefined') return;

    track.dataset.faynSizeWatched = 'true';
    new ResizeObserver(() => updateArrows(root)).observe(track);
  };

  const refreshAll = () => {
    document.querySelectorAll('[data-fayn-upsell]').forEach((root) => {
      watchSize(root);
      updateArrows(root);
    });
  };

  const scheduleRefresh = () => {
    refreshAll();
    [150, 400, 900].forEach((delay) => setTimeout(refreshAll, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
  } else {
    scheduleRefresh();
  }

  document.addEventListener('cart:update', scheduleRefresh);
  document.addEventListener('apps:product-added-to-cart', scheduleRefresh);

  // Scroll-Events bubbeln nicht, deshalb in der Capture-Phase.
  document.addEventListener(
    'scroll',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const track = target.closest('[data-fayn-upsell-track]');
      if (!track) return;
      const root = track.closest('[data-fayn-upsell]');
      if (root) updateArrows(root);
    },
    true
  );

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const prev = target.closest('[data-fayn-upsell-prev]');
    const next = target.closest('[data-fayn-upsell-next]');

    if (prev || next) {
      event.preventDefault();

      const root = (prev || next).closest('[data-fayn-upsell]');
      const track = root && root.querySelector('[data-fayn-upsell-track]');
      if (!track) return;

      const card = track.querySelector('.fayn-cart-upsell__card');
      const step = card ? card.getBoundingClientRect().width + CARD_GAP : track.clientWidth;
      track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
      setTimeout(() => updateArrows(root), 450);
      return;
    }

    const addButton = target.closest('[data-fayn-upsell-add]');
    if (!addButton) return;

    const variantId = addButton.getAttribute('data-fayn-upsell-add');
    if (!variantId) return;

    addButton.disabled = true;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      let cart = await fetchCart();

      const promoCode = addButton.getAttribute('data-fayn-upsell-code');
      if (promoCode && !cartHasDiscountCode(cart)) {
        try {
          const client = getDatoraClient();
          if (client) {
            const applied = await client.setDiscountCode(promoCode);
            if (!isRejected(applied)) cart = await fetchCart();
          } else {
            // Ohne Datora-Client wie in cart-discount.js: Code ueber die Warenkorb-API setzen.
            const response = await fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: promoCode }),
            });
            if (response.ok) cart = await response.json();
          }
        } catch (error) {
          console.error('Rabattcode konnte nicht gesetzt werden', error);
        }
      }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'fayn-cart-upsell',
            data: { source: 'fayn-cart-upsell', itemCount: cart.item_count, variantId: variantId },
          },
        })
      );
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
    } catch (error) {
      console.error('Produkt konnte nicht hinzugefuegt werden', error);
    } finally {
      addButton.disabled = false;
    }
  });
})();
